<nav
  id="app-sidenav"
  class="navbar drawer"
  [class.drawer--open]="nav.isOpen()"
  role="navigation"
>
  @if (navBarLogo(); as logo) {
    <img
      [src]="logo.path"
      [alt]="logo.alt"
      [style.width]="logo.width"
      [style.height]="logo.height"
      class="icon-afirma"
    />
  }

  <ul>
    @for (item of navItems(); track item) {
      <li class="nav-item" [class.is-open]="activeSubmenu === item.submenuKey">
        <div class="nav-parent">

            @if (item.label !== 'Cerrar sesión') {
              <a
                class="nav-link"
                [routerLink]="item.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="onParentClick(item)"
              >
                <img [src]="item.icon" alt="Icono" class="icon"/>
                <span class="texto-nav-link">{{ item.label }}</span>
              </a>
            } @else {
              <a
                class="nav-link"
                (click)="logout()"
              >
                <img [src]="item.icon" alt="Icono" class="icon"/>
                <span class="texto-nav-link">{{ item.label }}</span>
              </a>
            }


            @if (item.children?.length) {
              <button
                type="button"
                class="submenu-toggle"
                [class.expanded]="activeSubmenu === item.submenuKey"
                (click)="onCaretClick(item, $event)"
                [attr.aria-expanded]="activeSubmenu === item.submenuKey"
                [attr.aria-controls]="'submenu-' + item.submenuKey"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8 10l4 4 4-4" fill="none" stroke="currentColor" stroke-width="2"/>
                </svg>
              </button>
            }
          </div>

          @if (showSubmenu(item)) {
            <ul class="submenu-list" [id]="'submenu-' + item.submenuKey">
              @for (child of item.children; track child.label) {
                <li>
                  <a
                    class="nav-link"
                    [routerLink]="child.route"
                    routerLinkActive="active"
                    (click)="onChildClick()"
                  >
                    <span class="texto-nav-link">{{ child.label }}</span>
                  </a>
                </li>
              }
            </ul>
          }
      </li>
    }
  </ul>
</nav>
